import {
  Autocomplete,
  Checkbox,
  FormHelperText,
  TextField,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

const SELECT_ALL_VALUE = "__SELECT_ALL__";

type Props = {
  menuItems: string[];
  label: string;
  onSelect(values): void;
  selectedValues: string[];
  error?: boolean;
  helperText?: string;
};
export function MultiSelectComponent({
  menuItems,
  label,
  selectedValues,
  onSelect,
  error,
  helperText,
}: Props) {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const cleaned = (selectedValues || []).filter(
    (el) => el !== "" && el !== null && el !== undefined,
  );

  const allSelected =
    menuItems.length > 0 && cleaned.length === menuItems.length;
  const optionsWithSelectAll =
    menuItems.length > 0 ? [SELECT_ALL_VALUE, ...menuItems] : menuItems;

  return (
    <>
      <label className={styles.label}>{label}</label>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={optionsWithSelectAll}
        value={cleaned}
        onChange={(_, arr) => {
          const values = (arr || []) as string[];
          if (values.includes(SELECT_ALL_VALUE)) {
            const next = allSelected ? [] : [...menuItems];
            onSelect(next.join(","));
            return;
          }
          const next = values.filter(Boolean);
          onSelect(next.join(","));
        }}
        fullWidth
        className={styles.textEnabled}
        isOptionEqualToValue={(a, b) => String(a) === String(b)}
        getOptionLabel={(option) =>
          option === SELECT_ALL_VALUE ? t("COMMON.SELECT_ALL") : String(option)
        }
        renderOption={(props, option, { selected }) => {
          if (option === SELECT_ALL_VALUE) {
            return (
              <li {...props} key={SELECT_ALL_VALUE}>
                <Checkbox
                  checked={allSelected}
                  indeterminate={cleaned.length > 0 && !allSelected}
                />
                {t("COMMON.SELECT_ALL")}
              </li>
            );
          }
          return (
            <li {...props} key={String(option)}>
              <Checkbox checked={selected} />
              {String(option)}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            margin="none"
            error={error}
            autoComplete="off"
          />
        )}
      />
      {helperText ? (
        <FormHelperText
          error
          className={styles.errorText}
          sx={{
            textAlign: i18n.dir() === "rtl" ? "right" : "left",
          }}
        >
          {" "}
          {helperText}
        </FormHelperText>
      ) : null}
    </>
  );
}
